import React, { Suspense, lazy } from 'react'
import { Redirect, Route, Router, Switch } from 'react-router-dom'
import { FallbackView } from '../../_metronic/partials'
import { AllHotelsWrapper } from '../pages/dashboard/AllHotelsWrapper'

import { createBrowserHistory } from 'history'

import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import AuthVerify from '../common/auth-verify'
// import {MenuTestPage} from '../pages/MenuTestPage'

export function PrivateRoutes() {





  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const WeeklyWrapUpPage = lazy(() => import('../modules/WeeklyWrapUp/WeeklyWrapUpPage'))
  const UserPage = lazy(() => import('../modules/User/UserPage'))
  const SundriesShopProductPage = lazy(() => import('../modules/SundriesShopProducts/SundriesShopProductsPage'))
  const SundriesShopInventoryPage = lazy(() => import('../modules/SundriesShopInventory/SundriesShopInventoryPage'))
  const RolePage = lazy(() => import('../modules/Role/RolePage'))
  const PayrollReportPage = lazy(() => import('../modules/PayrollReport/PayrollReportPage'))
  const LinenItemPage = lazy(() => import('../modules/LinenItem/LinenItemPage'))

  const LinenInventoryPage = lazy(() => import('../modules/LinenInventory/LinenInventoryPage'))
  const HotelPage = lazy(() => import('../modules/Hotel/HotelPage'))

  const EmployeePage = lazy(() => import('../modules/Employee/EmployeePage'))
  const DepartmentPage = lazy(() => import('../modules/Department/DepartmentPage'))

  const FacilitiesInspectionPage = lazy(() => import('../modules/FacilitiesInspection/FacilitiesInspectionPage'))

  const VendorPage = lazy(() => import('../modules/Vendor/VendorPage'))

  const BreakfastPage = lazy(() => import('../modules/Breakfast/BreakfastPage'))

  const DocumentLibraryPage = lazy(() => import('../modules/DocumentLibrary/DocumentLibraryPage'))

  const EOMLibraryPage = lazy(() => import('../modules/EOMLibrary/EOMLibraryPage'))

  const SelfQAPage = lazy(() => import('../modules/SelfQALibrary/SelfQAPage'))
  // console.log('route changes****');

  // const history = createBrowserHistory();

  return (
    <Suspense fallback={<FallbackView />}>

        <Switch>

          <Route path='/dashboard' component={DashboardWrapper} />
          <Route path='/allHotels' component={AllHotelsWrapper} />

          <Route path='/widgets' component={WidgetsPage} />

          <Route path='/departments' component={DepartmentPage} />
          <Route path='/employees' component={EmployeePage} />
          <Route path='/hotels' component={HotelPage} />
          <Route path='/linenInventories' component={LinenInventoryPage} />
          <Route path='/linenItems' component={LinenItemPage} />
          <Route path='/payrollReport' component={PayrollReportPage} />
          <Route path='/roles' component={RolePage} />
          <Route path='/sundriesShopInventories' component={SundriesShopInventoryPage} />
          <Route path='/sundriesShopProducts' component={SundriesShopProductPage} />
          <Route path='/users' component={UserPage} />

          <Route path='/weeklyWrapUp' component={WeeklyWrapUpPage} />

          <Route path={'/FacilitiesInspection'} component={FacilitiesInspectionPage} />

          <Route path={'/BreakfastReport'} component={BreakfastPage} />

          <Route path={'/Vendors'} component={VendorPage} />

          <Route path={'/documentLibrary'} component={DocumentLibraryPage} />
          <Route path={'/eomLibrary'} component={EOMLibraryPage} />

          <Route path={'/selfQA'} component={SelfQAPage} />

          
          <Redirect from='/auth' to='/allHotels' />

          <Redirect exact from='/' to='/allHotels' />

          {/* <Redirect from='/auth' to='/dashboard' /> */}
          {/* <Redirect exact from='/' to='/dashboard' /> */}
          <Redirect to='error/404' />
        </Switch>

        <AuthVerify />

    </Suspense>
  )
}
